import { Link, useLocation } from "react-router-dom";
import { LEGAL_DOCS } from "../../content/legal";

export default function LegalNav() {
  const location = useLocation();
  return (
    <nav aria-label="Legal documents" data-testid="legal-nav" className="min-w-0">
      {/* Mobile: horizontal scroll row */}
      <div className="-mx-5 overflow-x-auto px-5 md:hidden">
        <ul className="flex w-max gap-2 pb-2">
          {LEGAL_DOCS.map((doc) => {
            const active = location.pathname === doc.slug;
            return (
              <li key={doc.slug} className="shrink-0">
                <Link
                  to={doc.slug}
                  data-testid={`legal-nav-mobile-${doc.slug.slice(1)}`}
                  aria-current={active ? "page" : undefined}
                  className={`inline-block whitespace-nowrap rounded-full px-4 py-2 font-glacial text-[14px] transition-colors ${
                    active
                      ? "bg-black text-white"
                      : "bg-[#F7F6F4] text-[#555555] hover:text-black"
                  }`}
                >
                  {doc.navLabel}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Desktop: sticky sidebar */}
      <ul className="sticky top-10 hidden space-y-1 md:block">
        {LEGAL_DOCS.map((doc) => {
          const active = location.pathname === doc.slug;
          return (
            <li key={doc.slug}>
              <Link
                to={doc.slug}
                data-testid={`legal-nav-${doc.slug.slice(1)}`}
                aria-current={active ? "page" : undefined}
                className={`block rounded-lg px-3 py-2.5 font-glacial text-[15px] transition-colors ${
                  active
                    ? "font-bold text-black"
                    : "text-[#7C7C7C] hover:text-black"
                }`}
              >
                {doc.navLabel}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
